export default "__VITE_ASSET__BfFBmvg5__"